export default __webpack_public_path__ + "static/media/heartMouth1.17ca2efd.png";